import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import Api from '../../lib/api'
import { useGetListItems } from '../../hooks/entityMethodsHook'

export const useGetFiles = (key: string, params: any) => {
  const { getAccessTokenSilently } = useAuth0()
  return useQuery(
    [key, params],
    async ({ queryKey }: any) => {
      const token = await getAccessTokenSilently()
      return await Api.get(`v1/files/search`, token, params)
    },
    {
      refetchOnWindowFocus: false,
      retry: 2,
    }
  )
}

export const useGetOne = (key: string, id: any) => {
  const { getAccessTokenSilently } = useAuth0()
  return useQuery(
    [key, id],
    async ({ queryKey }: any) => {
      const token = await getAccessTokenSilently()
      return await Api.get(`v1/files/${id}`, token)
    },
    {
      refetchOnWindowFocus: false,
      retry: 2,
    }
  )
}

export const useAddFiles = (key: any) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async (data: any) => {
      const token = await getAccessTokenSilently()
      return await Api.post(`v1/files`, data, token)
    },
    {
      onSuccess: data => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ['get-files'],
          }),
        ])
      },
    }
  )

  return mutation
}

export const useUpdateFiles = (key: any) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async (data: any) => {
      const token = await getAccessTokenSilently()
      return await Api.put(`v1/files/${data?.id}`, data, token)
    },
    {
      onSuccess: data => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ['get-files'],
          }),
        ])
      },
    }
  )

  return mutation
}

export const useDeleteFiles = (key: any) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async (id: any) => {
      const token = await getAccessTokenSilently()
      return await Api.delete(`v1/files/${id}`, token)
    },
    {
      onSuccess: data => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ['get-files'],
          }),
        ])
      },
    }
  )

  return mutation
}

export const useGetAllUsers = (key: any) => {
  const uri = `users/list`
  return useGetListItems(key, uri, true)
}
